import TextField from "@mui/material/TextField";


const MAX_LENGTH = 15; 

const isValidPhone = (phone) => {
  const regex = /^(?:\+254|0)(7|1)\d{8}$/;
  return regex.test(phone);
};

const hasDuplicates = (arr) => {
  const normalized = arr.map(p => p.trim());
  return new Set(normalized).size !== normalized.length;
};

const MultiPhoneInput = ({ name, values = [""], setFieldValue, requiredPrimary = false,
  allowEmpty = true, }) => {

  const normalize = (phones) => {
  let cleaned = [...phones];

  // Remove trailing empty inputs except the first one
  while (cleaned.length > 1 && cleaned[cleaned.length - 1].trim() === "") {
    cleaned.pop();
  }

  // Primary (first) must not be empty
  if (cleaned[0].trim() === "") {
    return cleaned; // keep it empty, let validation handle it
  }

  const nonEmpty = cleaned.filter(p => p.trim() !== "");

  const allValid = nonEmpty.every(isValidPhone);
  const noDuplicates = !hasDuplicates(nonEmpty);

  // Only add a new field if all current are valid
  if (allValid && noDuplicates && nonEmpty.length === cleaned.length && nonEmpty.length > 0) {
    cleaned.push("");
  }

  return cleaned;
};


  

const handleChange = (index, value) => {
  // Allow only numbers and + at the start
  let cleaned = value.replace(/(?!^\+)[^\d]/g, "");

  // Enforce max length (excluding +)
  const digitsOnly = cleaned.startsWith("+")
    ? cleaned.slice(1)
    : cleaned;

  if (digitsOnly.length > MAX_LENGTH) return;

  const updated = [...values];
  updated[index] = cleaned;
  setFieldValue(name, normalize(updated));
};


  const handleBlur = () => {
    setFieldValue(name, normalize(values));
  };

  const nonEmpty = values.filter(v => v.trim() !== "");
  const duplicateExists = hasDuplicates(nonEmpty);

  return (
    <div>
      {values.map((phone, index) => {
        console.log("Phone at index", index, "=", phone);
        const isPrimary = index === 0;

        const isDuplicate =
          phone.trim() !== "" &&
          nonEmpty.filter(p => p === phone).length > 1;

        const showError =
  (requiredPrimary && isPrimary && phone.trim() === "") ||
  (phone.length > 0 && !isValidPhone(phone)) ||
  isDuplicate;

        return (
          <div key={index} style={{ marginBottom: "1rem" }}>
            <TextField
              fullWidth
              variant="standard"
              label={isPrimary ? "Primary Phone Number *" : `Phone Number ${index + 1}`}
              value={phone}
              onChange={(e) => handleChange(index, e.target.value)}
              onBlur={handleBlur}
              error={showError}
              helperText={
                isPrimary && phone.trim() === ""
                  ? "Primary phone is required"
                  : isDuplicate
                  ? "Duplicate phone number"
                  : phone.length > 0 && !isValidPhone(phone)
                  ? "Enter valid phone number"
                  : ""
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default MultiPhoneInput;
